import moment from 'moment'
import { fetchCompany } from '@/api/parameters'
import numeral, { findFormat } from '@/numeral_locale/numeral_locale.js'

moment.locale('es')

export async function pdfPackingSlip(content) {
    var pdfMake = require('pdfmake/build/pdfmake.js')
    var pdfFonts = require('pdfmake/build/vfs_fonts.js')
    pdfMake.vfs = pdfFonts.pdfMake.vfs

    const company = await fetchCompany()
    const code = company.country_code
    numeral.locale(code)
    const isChile = code === 'cl' || code === 'CL'
    const numFormat = isChile ? '0,0' : '0,0.[0000]'

    const emited = content.date_emited
        ? moment(content.date_emited).format('DD-MMM-YYYY')
        : moment().format('DD-MMM-YYYY')

    pdfMake.fonts = {
        RobotoCondensed: {
            normal: 'https://s3.us-east-2.wasabisys.com/evo/media/public/config/fonts/RobotoCondensed-Regular.ttf',
            bold: 'https://s3.us-east-2.wasabisys.com/evo/media/public/config/fonts/RobotoCondensed-Bold.ttf',
        },
    }

    const dd = {
        pageSize: 'LETTER',
        content: [
            // Logo
            {
                image: 'logo',
                width: 120,
                margin: [0, 0, 0, 10],
            },
            // Datos empresa (izquierda)
            {
                layout: 'noBorders',
                table: {
                    widths: [320],
                    body: [
                        [{ text: company.name, bold: true }],
                        [{ text: company.giro }],
                        [{ text: company.address }],
                        [{ text: 'Telf.: ' + company.phone + ' - ' + company.email }],
                    ],
                },
            },
            // Fecha
            { text: 'Fecha: ' + emited, alignment: 'right', fontSize: 12, margin: [0, 8, 0, 0] },
            // Recuadro "Guía de Despacho" (esquina superior derecha)
            {
                absolutePosition: { x: 395, y: 50 },
                margin: [0, 10, 0, 0],
                layout: 'noBorders',
                table: {
                    widths: [170],
                    heights: [25, 10, 40, 10],
                    body: [
                        [{ text: 'RUT.: ' + company.rut, alignment: 'center', fontSize: 12, color: 'red' }],
                        [{ text: 'Guía de Despacho', alignment: 'center', fontSize: 18, bold: true }],
                        [{ text: 'Nro. ' + content.id, alignment: 'center', fontSize: 20, bold: true }],
                        [{ text: 'Documento interno — no tributario', alignment: 'center', fontSize: 7, color: '#888' }],
                    ],
                },
            },
            {
                absolutePosition: { x: 390, y: 45 },
                canvas: [{
                    type: 'rect', x: 0, y: 0, w: 180, h: 90, r: 1, lineWidth: 3, lineColor: 'red', color: '',
                }],
            },
            // Receptor + Transporte (dos columnas al mismo nivel)
            {
                margin: [0, 10, 0, 0],
                layout: 'noBorders',
                table: {
                    widths: ['55%', '5%', '40%'],
                    body: [[
                        // Columna izquierda: datos del receptor
                        {
                            layout: 'noBorders',
                            table: {
                                widths: ['25%', '75%'],
                                body: [
                                    [{ text: 'Señor(es):', alignment: 'left' }, { text: content.rznSocRecep || '', bold: true }],
                                    [{ text: 'RUT:', alignment: 'left' }, { text: content.rutRecep || '', bold: true }],
                                    [{ text: 'Giro:', alignment: 'left' }, { text: content.giroRecep || '', bold: true }],
                                    [{ text: 'Dirección:', alignment: 'left' }, { text: (content.dirRecep || '') + (content.cmnaRecep ? ', ' + content.cmnaRecep : ''), bold: true }],
                                    content.glosa
                                        ? [{ text: 'Referencia:', alignment: 'left' }, { text: content.glosa, bold: true }]
                                        : [{}, {}],
                                ],
                            },
                        },
                        // Separador
                        {},
                        // Columna derecha: datos de transporte (solo si hay datos)
                        buildTransportBlock(content),
                    ]],
                },
            },
            // Tabla de productos
            {
                margin: [0, 10, 0, 0],
                layout: 'lightHorizontalLines',
                style: 'table',
                table: {
                    headerRows: 1,
                    widths: ['6%', '12%', '52%', '15%', '15%'],
                    body: buildDetailsTable(content.details || [], numFormat),
                },
            },
            // Observaciones
            content.notes
                ? {
                    margin: [0, 10, 0, 0],
                    layout: 'noBorders',
                    table: {
                        widths: ['15%', '85%'],
                        body: [[
                            { text: 'Observaciones:', alignment: 'left' },
                            { text: content.notes },
                        ]],
                    },
                }
                : {},
            // Área de firma del receptor
            {
                margin: [0, 40, 0, 0],
                layout: 'noBorders',
                table: {
                    widths: ['55%', '5%', '40%'],
                    body: [[
                        {
                            stack: [
                                { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 280, y2: 0, lineWidth: 1, lineColor: '#555' }] },
                                { text: 'Recibido conforme por:', margin: [0, 4, 0, 2] },
                                { text: 'Nombre: _______________________________', margin: [0, 4, 0, 2] },
                                { text: 'RUT: _______________________________', margin: [0, 2, 0, 2] },
                                { text: 'Fecha de recepción: __________________', margin: [0, 2, 0, 0] },
                            ],
                        },
                        {},
                        {
                            stack: [
                                {
                                    canvas: [{
                                        type: 'rect', x: 0, y: 0, w: 190, h: 80, lineWidth: 1, lineColor: '#555', color: '',
                                    }],
                                },
                                { text: 'Firma', alignment: 'center', margin: [0, 4, 0, 0] },
                            ],
                        },
                    ]],
                },
            },
        ],
        footer: {
            columns: [{
                text: (company.fantasy || company.name) + ' — ' + (company.webpage || ''),
                alignment: 'center',
                style: 'footer',
                margin: [0, 10, 0, 0],
            }],
        },
        images: {
            logo: company.logo_url,
        },
        defaultStyle: {
            font: 'RobotoCondensed',
            fontSize: 10,
            color: '#5B5A59',
        },
        styles: {
            table: { font: 'RobotoCondensed', fontSize: 10, color: '#5B5A59' },
            footer: { font: 'RobotoCondensed', fontSize: 8, color: '#5B5A59' },
        },
    }

    pdfMake.createPdf(dd).open()
}

function buildTransportBlock(content) {
    const plate = (content.vehicle_plate || '').trim()
    const driver = (content.driver_name || '').trim()
    const driverRut = (content.driver_rut || '').trim()

    if (!plate && !driver && !driverRut) return {}

    const rows = [
        [{ text: 'Transporte', bold: true, colSpan: 2, fontSize: 9, color: '#555' }, {}],
    ]
    if (plate) rows.push([{ text: 'Patente:', fontSize: 9 }, { text: plate, bold: true, fontSize: 9 }])
    if (driver) rows.push([{ text: 'Conductor:', fontSize: 9 }, { text: driver, bold: true, fontSize: 9 }])
    if (driverRut) rows.push([{ text: 'RUT:', fontSize: 9 }, { text: driverRut, bold: true, fontSize: 9 }])

    return {
        layout: 'noBorders',
        table: {
            widths: ['35%', '65%'],
            body: rows,
        },
    }
}

function buildDetailsTable(details, numFormat) {
    const body = []
    body.push([
        'Item',
        { text: 'SKU', alignment: 'left' },
        'Descripción',
        { text: 'Cantidad', alignment: 'right' },
        { text: 'Unidad', alignment: 'right' },
    ])

    details.forEach((item, index) => {
        body.push([
            { text: index + 1, alignment: 'center', border: [false, false, false, true], margin: [0, 3, 0, 3] },
            { text: item.sku || '', border: [false, false, false, true], margin: [0, 3, 0, 3] },
            {
                stack: [
                    { text: item.name || '' },
                    item.notes ? { text: 'Obs: ' + item.notes, italics: true, fontSize: 8, color: '#888' } : {},
                ],
                border: [false, false, false, true],
                margin: [0, 3, 0, 3],
            },
            { text: numeral(item.qty).format(numFormat), alignment: 'right', border: [false, false, false, true], margin: [0, 3, 0, 3] },
            { text: item.unit || 'UN', alignment: 'right', border: [false, false, false, true], margin: [0, 3, 0, 3] },
        ])
    })

    return body
}
